import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ColGroup, TableHead } from '../common';
import { useTableStoreValue } from '../TableContext';
import { StyledTable } from './TableShell';

export type WithStickyHeaderIfApplicableProps = PropsWithChildren;

export const WithStickyHeaderIfApplicable: FC<
  WithStickyHeaderIfApplicableProps
> = (props) => {
  const [table] = useTableStoreValue('table');
  const [sticky] = useTableStoreValue('sticky');

  if (!sticky) {
    return props.children;
  }

  return (
    <>
      <StickyHeaderTable>
        <ColGroup cols={table.getHeaderGroups()[0]} />
        <TableHead />
      </StickyHeaderTable>
      {props.children}
    </>
  );
};

const StickyHeaderTable = styled(StyledTable)`
  position: sticky;
  left: 0;
  top: 0;
  z-index: 2;
`;
